module.exports = __webpack_public_path__ + "img/delete.8717383a.svg";